// extracted by mini-css-extract-plugin
module.exports = {"root":"yHH9f","ShinyMenuIIButtonNSkin":"_1AqnT","shinyMenuIiButtonNSkin":"_1AqnT","linkElement":"_3Txgz","extra":"_1x-Cd","wrapper":"gOcWf","label":"_18iqC"};